import './App.css';
import ATMBranchLocator from './atmlocator.jsx';


function App() {
  return (
    <div className="">
    <ATMBranchLocator/>
    </div>
  );
}

export default App;
